import { z } from "zod";

/**
 * A crash report from the browser (window.onerror, unhandled promise rejections). No PII:
 * the web client scrubs emails and long digit runs before it sends, and the API caps every field.
 */
export const clientErrorReportSchema = z.object({
  kind: z.enum(["error", "rejection"]),
  message: z.string().max(500),
  stack: z.string().max(4000).optional(),
  source: z.string().max(300).optional(),
  line: z.number().int().nonnegative().optional(),
  column: z.number().int().nonnegative().optional(),
  /** Route pattern-ish path, ids included, never a query string. */
  path: z.string().max(200).optional(),
  build: z.string().max(40).optional(),
  userAgent: z.string().max(300).optional(),
});
export type ClientErrorReport = z.infer<typeof clientErrorReportSchema>;

/** Masks emails, phone-length digit runs and VINs. Both sides run it: the browser before send, the API before logging. */
export const scrubPii = (s: string) =>
  s
    .replace(/[^\s@"'<>]+@[^\s@"'<>]+\.[a-z]{2,}/gi, "[email]")
    .replace(/\b[A-HJ-NPR-Z0-9]{17}\b/g, "[vin]")
    .replace(/[+(]?\d[\d\s().-]{8,}\d/g, "[number]");
